import { useState } from 'react';
import { AlertCircle, Braces, Check } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'json',
  renderInput: ({ value, onChange }) => {
    const [text, setText] = useState<string>(
      value == null ? '' : typeof value === 'string' ? value : JSON.stringify(value, null, 2),
    );
    const [error, setError] = useState<string | null>(null);

    const handleChange = (v: string) => {
      setText(v);
      if (!v.trim()) {
        setError(null);
        onChange(null);
        return;
      }
      try {
        const parsed = JSON.parse(v);
        setError(null);
        onChange(parsed);
      } catch (e) {
        setError((e as Error).message);
      }
    };

    const format = () => {
      try {
        const parsed = JSON.parse(text);
        const fmt = JSON.stringify(parsed, null, 2);
        setText(fmt);
        setError(null);
        onChange(parsed);
      } catch (e) {
        setError((e as Error).message);
      }
    };

    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 text-xs">
            {error ? (
              <>
                <AlertCircle className="h-3.5 w-3.5 text-danger-500" />
                <span className="text-danger-500">Błąd składni</span>
              </>
            ) : text.trim() ? (
              <>
                <Check className="h-3.5 w-3.5 text-success-600" />
                <span className="text-success-600">Poprawny JSON</span>
              </>
            ) : null}
          </div>
          <button
            type="button"
            onClick={format}
            className="text-xs font-medium text-accent-600 hover:text-accent-700"
          >
            Formatuj
          </button>
        </div>
        <textarea
          value={text}
          onChange={(e) => handleChange(e.target.value)}
          rows={10}
          className={`w-full resize-y rounded-md border px-3 py-2 font-mono text-sm text-text-primary focus:outline-none focus:ring-1 focus:ring-accent-500 ${
            error
              ? 'border-danger-300 bg-danger-50'
              : 'border-border-primary bg-bg-primary focus:border-accent-500'
          }`}
          placeholder={'{\n  "key": "value"\n}'}
        />
        {error && <p className="rounded bg-danger-50 p-2 text-xs text-danger-600">{error}</p>}
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    const preview = (typeof value === 'string' ? value : JSON.stringify(value)).slice(0, 50);
    return (
      <div className="flex items-center gap-2">
        <Braces className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <code className="rounded bg-bg-secondary px-2 py-0.5 font-mono text-xs text-text-primary">
          {preview}…
        </code>
      </div>
    );
  },
  validate: (value, field) => {
    if (value == null) return field.isRequired ? 'Pole wymagane' : null;
    if (typeof value === 'object') return null;
    try {
      JSON.parse(String(value));
      return null;
    } catch {
      return 'Nieprawidłowy JSON';
    }
  },
  defaultValue: null,
});
